import React from "react";
import { LocalFolder } from "./LocalFilesFolders";
import { FolderView } from "@pages/Project/components/ProjectPageHeader";

const useLocalFiles = ({
  projectId,
  folderLoading,
  setFolderLoading,
  folderView,
  setFolderView,
  checkedItems,
  setCheckedItems,
  setCurrentPage,
  setFolderTotalPages,
  setRefreshOpenedFolder,
}: {
  projectId: string | undefined;
  folderLoading: boolean;
  setFolderLoading: React.Dispatch<React.SetStateAction<boolean>>;
  folderView: FolderView | null;
  setFolderView: React.Dispatch<React.SetStateAction<FolderView | null>>;

  checkedItems: string[];
  setCheckedItems: React.Dispatch<React.SetStateAction<string[]>>;
  setCurrentPage?: (page: number) => void;
  setFolderTotalPages: React.Dispatch<React.SetStateAction<number>>;
  setRefreshOpenedFolder: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const mapFilesForView = (dataFiles: any[]) => dataFiles;

  const handleOpenFolder = async (folderId: number, page = 1) => {
    if (!projectId) return;
    try {
      setFolderLoading(true);
      const data = await (
        await import("@services/LocalFolderService")
      ).localFolderService.getFolderView(projectId, folderId, page);

      setFolderView({
        parent_id: data.parent_id ?? null,
        folders: data.folders,
        files: mapFilesForView(data.files),
        breadcrumbs: data.breadcrumbs,
      });

      // sync client pagination with server
      setCurrentPage?.(data.page ?? 1);
      setFolderTotalPages(data.total_pages ?? 1);
    } finally {
      setFolderLoading(false);
    }
  };

  //  Breadcrumb navigation (Root -> goRoot, leaf -> getFolderView)
  const handleNavigateBreadcrumb = async (folderId: number | null) => {
    if (folderId == null) {
      setCurrentPage?.(1);
      await handleOpenFolder(0, 1);
      return;
    }
    await handleOpenFolder(folderId);
  };

  const handleFolderCreated = async (created: LocalFolder) => {
    setRefreshOpenedFolder((prev) => prev + 1);
  };

  return {
    handleOpenFolder,
    handleNavigateBreadcrumb,
    handleFolderCreated,
  };
};

export default useLocalFiles;
